import { DeleteOutlined }      from '@ant-design/icons';
import { Button }              from 'antd';
import { Card }                from 'antd';
import React                   from 'react';
import { observer }            from 'mobx-react';
import { List }                from 'antd';
import { EditOutlined }        from '@ant-design/icons';
import { FileOutlined }        from '@ant-design/icons';
import { PlusOutlined }        from '@ant-design/icons';
import { ApiCollection }       from 'collections/ApiCollection';
import StandLayoutForm         from 'forms/StandLayoutForm';
import LayoutTypeModel         from 'models/LayoutTypeModel';
import StandLayoutModel        from 'models/StandLayoutModel';
import { standDashboardStore } from 'stores/index';
import handleApiError          from 'utils/handleApiError';
import { formatMessageIntl }   from 'utils/messageIntl';
import modalConfirmDelete      from 'utils/modalConfirmDelete';
import CardBox                 from 'components/App/CardBox';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import { AppForm }             from 'components/App/AppForm';
import rights                  from 'utils/rights';

const StandLayoutItem = observer(({
  collLayoutType,
  openModal,
  standLayout,
}: {
  collLayoutType: ApiCollection;
  openModal: () => void;
  standLayout: StandLayoutModel;
}) => {
  const layoutType = collLayoutType.findBy('id', standLayout.layoutTypeId) as LayoutTypeModel|undefined;

  return (
    <List.Item
      key={standLayout.id}
    >
      <Card
        extra={[
          rights.for.standLayout.edit && <Button
            icon={<EditOutlined />}
            key="edit"
            onClick={openModal}
            size="small"
          />,
          rights.for.standLayout.edit && <Button
            danger={true}
            icon={<DeleteOutlined />}
            key="delete"
            onClick={() => {
              modalConfirmDelete({
                onOk: async () => {
                  try {
                    await standLayout.destroy();
                    standDashboardStore.collPagedStandLayout.setPage(1);
                    await standDashboardStore.collPagedStandLayout.list();
                  } catch (err) {
                    handleApiError(err);
                  }
                },
                title: formatMessageIntl("Êtes-vous sûr de vouloir supprimer cet aménagement ?"),
              });
            }}
            size="small"
          />
        ]}
        size="small"
        // style={{ width: 300 }}
        title={<span style={{ color: layoutType?.color, fontWeight: 'bold', }}>{layoutType?.label}</span>}
      >
        <p>{standLayout.description}</p>
      </Card>
    </List.Item>
  );
});

const styleIcon = {
  fontSize: '22px',
  marginRight: 6,
};

@observer
class StandLayoutListBox extends React.Component {
  public state: {
    form: {
      mode: 'add' | 'edit';
      model: StandLayoutModel;
    };
  } = {
      form: {
        mode: 'add',
        model: new StandLayoutModel(),
      }
    };

  public render() {
    const {
      collPagedStandLayout,
      collLayoutType,
      stand,
    } = standDashboardStore;

    return (
      <CardBox
        content={
          <List
            dataSource={[ ...collPagedStandLayout.models, ] as StandLayoutModel[]}
            grid={{
              column: 2,
              gutter: 8,
            }}
            loading={collPagedStandLayout.isLoading}
            locale={{
              emptyText: <FormattedMessageWrapper id="Aucun aménagement." />,
            }}
            pagination={{
              current: collPagedStandLayout.page,
              defaultCurrent: collPagedStandLayout.page,
              hideOnSinglePage: true,
              onChange: async page => {
                collPagedStandLayout.setPage(page);
                await collPagedStandLayout.list();
              },
              pageSize: collPagedStandLayout.itemsPerPage,
              size: 'small',
              total: collPagedStandLayout.total,
            }}
            renderItem={(item: StandLayoutModel) => (
              <StandLayoutItem
                collLayoutType={collLayoutType}
                openModal={() => {
                  AppForm.open(StandLayoutForm, {
                    model: item,
                    onSuccess: async () => {
                      collPagedStandLayout.setPage(1);
                      await collPagedStandLayout.list();
                    },
                    stand: stand,
                  }, {
                    title: <FormattedMessageWrapper id="Modifier un aménagement" />,
                  });
                }}
                standLayout={item}
              />
            )}
            size="large"
          />
        }
        extra={
          rights.for.standLayout.add && (
            <Button
              icon={<PlusOutlined />}
              onClick={() => {
                AppForm.open(StandLayoutForm, {
                  model: new StandLayoutModel(),
                  onSuccess: async () => {
                    collPagedStandLayout.setPage(1);
                    await collPagedStandLayout.list();
                  },
                  stand: stand,
                }, {
                  title: <FormattedMessageWrapper id="Ajouter un aménagement" />,
                });
              }}
              style={{
                alignItems: 'center',
                display: 'flex',
                gap: '8px',
              }}
            >
              <FormattedMessageWrapper id="Ajouter un aménagement" />
            </Button>
          )
        }
        loading={collPagedStandLayout.isLoading}
        title={
          <>
            <FileOutlined style={styleIcon} /> <FormattedMessageWrapper id="Aménagements" />
          </>
        }
      />
    );
  }
}

export default StandLayoutListBox;
